import { render, staticRenderFns } from "./TermsOfService.vue?vue&type=template&id=bc18ef6a"
import script from "./TermsOfService.vue?vue&type=script&lang=ts"
export * from "./TermsOfService.vue?vue&type=script&lang=ts"
import style0 from "./TermsOfService.vue?vue&type=style&index=0&id=bc18ef6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports